import type { PricingPlan } from "./pricing";

/**
 * TaM "Tarif bleu" (reduced fare), hardcoded until an API gives the rider's eligibility (decision
 * 14/10/2026); the public fare comes from the GBFS plans. Figma 05b and the A0 prices page.
 */
export const TARIF_BLEU = {
  perMinute: "0,21 € / min",
  unlock: "déverrouillage offert",
  perMinuteCents: 21,
  unlockCents: 0,
} as const;
export const TARIF_BLEU_LABEL = `Tarif bleu : ${TARIF_BLEU.perMinute}, ${TARIF_BLEU.unlock}`;

export type Tab = "public" | "bleu";

/**
 * Figma A0 pass catalogue (no source yet: no pass API, display only). Prices per tariff in cents;
 * the price per minute and the saving are computed against the tab's own per-minute rate.
 */
export const PASSES = [
  { minutes: 30, name: "Aller-retour", cents: { public: 599, bleu: 299 } },
  { minutes: 60, name: "Pass 60 min", cents: { public: 1199, bleu: 599 } },
  { minutes: 200, name: "Hebdomadaire", cents: { public: 3599, bleu: 1799 } },
  { minutes: 400, name: "Mensuel", cents: { public: 6699, bleu: 3199 } },
] as const;
/** Vélotaf: tarif bleu only. */
export const VELOTAF_CENTS = 4499;

const euros = (cents: number) => `${(cents / 100).toFixed(2).replace(".", ",")} €`;

export function passView(p: (typeof PASSES)[number], tab: Tab, perMinuteCents: number) {
  const perMin = (q: (typeof PASSES)[number]) => q.cents[tab] / q.minutes;
  const unit = perMin(p);
  const saving = Math.round((1 - unit / perMinuteCents) * 100);
  return {
    price: euros(p.cents[tab]),
    perMinute: `soit ${euros(Math.round(unit))} / min`,
    ...(saving > 0 && { discount: `-${saving} %` }),
    best: PASSES.every((q) => perMin(q) >= unit),
  };
}

/** The public per-minute tariff: the e-bike plan of the GBFS feed (else the first per-minute one). */
export function publicTariff(
  plans: Record<string, PricingPlan>,
): { perMinuteCents: number; unlockCents: number } | undefined {
  const perMinute = Object.values(plans).filter((p) => p.segments[0]?.intervalMin === 1);
  const plan = perMinute.find((p) => /ebike/i.test(p.id)) ?? perMinute[0];
  const rate = plan?.segments[0];
  return plan && rate
    ? { perMinuteCents: rate.rateCents, unlockCents: plan.unlockCents }
    : undefined;
}
